"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isProgramOwnedTreeRuleV2 = exports.getProgramOwnedTreeRuleV2Serializer = exports.programOwnedTreeV2 = void 0;
const serializers_1 = require("@metaplex-foundation/umi/serializers");
const rule_1 = require("./rule");
const ruleHeader_1 = require("./ruleHeader");
const ruleType_1 = require("./ruleType");
const programOwnedTreeV2 = (pubkeyField, proofField, root) => ({
    type: 'ProgramOwnedTree',
    pubkeyField,
    proofField,
    root: [...root],
});
exports.programOwnedTreeV2 = programOwnedTreeV2;
const getProgramOwnedTreeRuleV2Serializer = () => (0, ruleHeader_1.wrapSerializerInRuleHeaderV2)(ruleType_1.RuleTypeV2.ProgramOwnedTree, (0, serializers_1.struct)([
    ['pubkeyField', (0, serializers_1.string)({ size: 32 })],
    ['proofField', (0, serializers_1.string)({ size: 32 })],
    [
        'root',
        (0, serializers_1.mapSerializer)((0, serializers_1.bytes)({ size: 32 }), (v) => new Uint8Array(v), (v) => [...v]),
    ],
]));
exports.getProgramOwnedTreeRuleV2Serializer = getProgramOwnedTreeRuleV2Serializer;
const isProgramOwnedTreeRuleV2 = (rule) => (0, rule_1.isRuleV2)(rule) && rule.type === 'ProgramOwnedTree';
exports.isProgramOwnedTreeRuleV2 = isProgramOwnedTreeRuleV2;
//# sourceMappingURL=programOwnedTree.js.map